import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VehiclesComponent extends DestructorComponent{
  vehiclesChildren: Route[] = [];
  user:any;

  constructor(private router: Router, private _globalStateService: GlobalStateService) { super(); }

  ngOnInit(): void {
    const vehiclesRoute = this.router.config.find(r => r.path === 'vehicles');

    // Get only first-level children
    this.vehiclesChildren = vehiclesRoute?.children ?? [];

    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if(this.user?.role_complete.is_admin){
            this.vehiclesChildren = vehiclesRoute?.children ?? [];
        }
        else{
            this.vehiclesChildren = this.vehiclesChildren.filter((child:any) => {
              return this.user?.role_complete.permissions[child.path]?.view;
            });
        }
      })
    );
  }
}
